export enum Liveness {
  LIVE = 'live',
  TEST = 'test',
}

export enum KycSessionStatus {
  CREATED = 'created',
  STARTED = 'started',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export enum KycCheckStatus {
  CREATED = 'created',
  PENDING = 'pending',
  PASSED = 'passed',
  FAILED = 'failed',
  CANCELED = 'canceled',
}
